/**
 * Sprint v1.6 Stufe 4B (Mi 02.09.2026) — Zugangscode.
 *
 * Mini-Sektion im Cockpit: „Was dein Gegenüber zuerst hören muss."
 * Zeigt pro Fokustyp den zentralen „Zugangscode" — das eine Ding, das
 * für diesen Fokus zuerst stimmig sein muss, damit die Tür überhaupt aufgeht.
 *
 * Sprachprinzip v8: Alltagssprache, keine Anglizismen, keine Coach-Sprache.
 * Copy morgen früh (03.09.) durch Andreas redaktionell reviewt.
 */
import React from "react";
import { KeyRound } from "lucide-react";

const ZUGANGSCODE_COPY = {
  eule: {
    was: "Der Sinn dahinter.",
    warum:
      "Warum das jetzt? Warum genau so? — Ohne diese Antwort steht die Eule mit verschränkten Armen.",
  },
  biene: {
    was: "Ein sauberer Plan.",
    warum:
      "Erst der Weg, dann der Rest. Ohne Struktur zieht sich die Biene zurück und stellt Nachfragen.",
  },
  katze: {
    was: "Ein Reiz, der Lust macht.",
    warum:
      "\u201eWeil es sinnvoll ist\u201c reicht nicht. Die Katze braucht etwas, das SIE reizt — nicht ein Argument.",
  },
  hund: {
    was: "Ein Beziehungs-Anker.",
    warum:
      "Erst \u201eich meine dich\u201c, dann \u201edarum geht's\u201c. Ohne diesen Anker läuft der Hund im Kopf woanders.",
  },
};

const NAME = { eule: "Eule", biene: "Biene", katze: "Katze", hund: "Hund" };

export default function Zugangscode({ slug }) {
  const active = slug && ZUGANGSCODE_COPY[slug] ? slug : "eule";
  const copy = ZUGANGSCODE_COPY[active];

  return (
    <section
      className="rounded-2xl bg-slate-900 text-white p-6"
      data-testid="zugangscode-section"
      data-fokustyp={active}
    >
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 flex-shrink-0 rounded-full bg-white/10 flex items-center justify-center">
          <KeyRound className="w-5 h-5 text-amber-300" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-bold uppercase tracking-widest text-amber-300">
            Zugangscode
          </p>
          <h3
            className="mt-1 text-lg sm:text-xl font-extrabold"
            data-testid="zugangscode-titel"
          >
            Was dein Gegenüber zuerst hören muss.
          </h3>
          <p
            className="mt-3 text-2xl sm:text-3xl font-extrabold text-amber-300 leading-tight"
            data-testid="zugangscode-was"
          >
            {copy.was}
          </p>
          <p
            className="mt-3 text-sm text-slate-200 leading-relaxed"
            data-testid="zugangscode-warum"
          >
            Für die <strong>{NAME[active]}</strong>: {copy.warum}
          </p>
        </div>
      </div>
    </section>
  );
}
